/**
 * Debug: There hasn't necessarily been an error or failure but are intended for diagnostics and pinpointing problems.
 * e.g. logger.log(LogLevel.Debug, TAG, "origin: $formattedUrl")
 *
 * Info: Used for logging events intended for informational purposes.
 * e.g. logger.log(LogLevel.Info, TAG, "now on main thread, calling jS functions")
 *
 * Warn: Indicates that something unexpected happened, a problem, or a situation that might disturb one of the processes.
 * e.g. logger.log(LogLevel.Warn, "UnsupportedEvent", "Unsupported event raised with name : $registerMessage")
 *
 * Error: Indicates something has gone wrong and an error was generated in a normal flow at runtime.
 * e.g. logger.log(LogLevel.Error, TAG, "Invalid auth url", e)
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["Debug"] = "Debug";
    LogLevel["Info"] = "Info";
    LogLevel["Warn"] = "Warn";
    LogLevel["Error"] = "Error";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=logger.js.map